module.exports = __webpack_public_path__ + "img/vacance3.bfa32fc2.png";